import React from 'react';
import { FormattedMessage } from 'react-intl';

const FormattedMessages = {
  backText: <FormattedMessage id="Global.BackText" defaultMessage="Back" />,
  searchingText: (
    <FormattedMessage
      id="ReportsList.SearchingText"
      defaultMessage="Searching..."></FormattedMessage>
  ),
  dateText: (
    <FormattedMessage id="ReportsIndex.dateText" defaultMessage="Date" />
  ),
  typeText: (
    <FormattedMessage
      id="ReportsList.Type"
      defaultMessage="Type"></FormattedMessage>
  ),
  userText: (
    <FormattedMessage
      id="ReportsList.User"
      defaultMessage="User"></FormattedMessage>
  ),
  fromText: (
    <FormattedMessage
      id="ReportsList.From"
      defaultMessage="From"></FormattedMessage>
  ),
  toText: (
    <FormattedMessage
      id="ReportsList.To"
      defaultMessage="To"></FormattedMessage>
  ),
  actionText: (
    <FormattedMessage
      id="ReportsList.ActionText"
      defaultMessage="Action"></FormattedMessage>
  ),
  clear: (
    <FormattedMessage id="ReportsList.Clear" defaultMessage="Clear Filters" />
  ),
};

export default FormattedMessages;
